import sc, {keyframes} from 'styled-components';
import {UnifonTheme} from '@phonectas/unifon-ui-kit';

const slideDown = keyframes`
	from {
		transform: translate(-50%, -120%);
		opacity: 0;
	}
	to {
		transform: translate(-50%, 0);
		opacity: 1;
	}
`;

const shimmer = keyframes`
	0%, 100% {
		transform: scale(1) rotate(0deg);
	}
	50% {
		transform: scale(1.12) rotate(8deg);
	}
`;

export const StyledNotice = sc.div<{theme: UnifonTheme}>`
	position: fixed;
	top: 12px;
	left: 50%;
	transform: translate(-50%, 0);
	z-index: 10000;
	display: flex;
	align-items: center;
	gap: 14px;
	min-width: 380px;
	max-width: calc(100vw - 32px);
	padding: 12px 12px 12px 14px;
	border-radius: 12px;
	background-color: white;
	border: 1px solid rgba(0, 27, 116, 0.08);
	box-shadow: 0 10px 30px rgba(0, 27, 116, 0.18), 0 2px 6px rgba(0, 27, 116, 0.08);
	animation: ${slideDown} 0.35s cubic-bezier(0.2, 0.9, 0.3, 1.2);
`;

export const StyledIconBadge = sc.div`
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	border-radius: 50%;
	background: linear-gradient(135deg, #DEE9FB 0%, #E9F7E9 100%);

	svg {
		animation: ${shimmer} 2.4s ease-in-out infinite;
	}
`;

export const StyledTexts = sc.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	flex: 1;
	min-width: 0;
`;

export const StyledTitle = sc.span<{theme: UnifonTheme}>`
	font-size: 15px;
	font-weight: 600;
	color: ${({theme}) => theme['palette'].primary};
`;

export const StyledMessage = sc.span<{theme: UnifonTheme}>`
	font-size: 14px;
	color: ${({theme}) => theme['palette'].textSecondary};
`;
